{
    "PaginatedList_Search": "Zoek op",
    "PaginatedList_Search_NoResults": "Er zijn geen extensies gevonden die aan deze zoekopdracht voldoen",
    "NAME": "PaginatedList"
}